<template>
  <core-sidebar sidebar-class="w-75 w-lg-25" id="notebook-sidebar" right header-class="bg-portal-primary p-3" body-class="p-3" footer-class="px-3" shadow backdrop>
    <template #header="{ hide }">
      <b-row align-v="center" class="flex-grow-1">
        <b-col class="d-flex">
          <span class="fs-5 fw-bolder text-white">
            <b-icon icon="journal-bookmark" class="mr-2"></b-icon>
            {{ translations[10966] }}
          </span>
        </b-col>
        <b-col cols="auto" class="d-flex ml-auto">
          <b-button class="bg-transparent border-0 p-1" @click="hide()">
            <b-icon icon="x" font-scale="1.5"></b-icon>
          </b-button>
        </b-col>
      </b-row>
    </template>
    <template #default>
      <div class="accordion" role="tablist">
        <b-card v-if="isNotebookJobsHidden" no-body class="mb-0 border-0">
          <b-card-header header-tag="header" class="accordion-header p-0 fw-light border-0" role="tab">
            <b-button block v-b-toggle.accordion-notebook-1 variant="light"
                      class="accordion-button text-left d-flex align-items-center shadow-none rounded-bottom-0">
              <span class="fw-bolder">{{ translations[12604] }} </span> ({{ notebookJobs.length }})
            </b-button>
          </b-card-header>
          <b-collapse class="border-0" id="accordion-notebook-1" visible accordion="notebook-accordion" role="tabpanel">
            <b-card-body class="fs-6 px-0 py-3">
              <notebook-item
                v-for="(item, index) in notebookJobs"
                :key="index"
                :date="formatDateEuropean(item.lastdate)"
                :id="item.id"
                :title="item.position"
                :description="item.location"
                @delete="deleteNotepadJob(item.id)"
                >
                <template #title="{ title }">
                  <span class="fw-bold link-primary stretched-link" v-b-toggle.jobs-sidebar @click="handleJobSidebar(item.id, item.company_name, item.shortview)">
                    {{ title }}
                  </span>
                </template>
              </notebook-item>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card v-if="isNotebookWorkersHidden" no-body class="mb-0 border-0">
          <b-card-header header-tag="header" class="accordion-header p-0 fw-light border-0" role="tab">
            <b-button block v-b-toggle.accordion-notebook-2 variant="light"
                      class="accordion-button text-left d-flex align-items-center shadow-none rounded-0">
              <span class="fw-bolder">{{ isCourses ? translations[15399] : translations[4741] }} </span> ({{ notebookWorkers.length }})
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-notebook-2" accordion="notebook-accordion" role="tabpanel">
            <b-card-body class="fs-6 px-0 py-3">
              <notebook-item
                v-for="(item, index) in notebookWorkers"
                :key="index"
                :date="formatDateEuropean(item.last_modified)"
                :id="item.id"
                :title="item.position"
                :description="item.locations"
                @delete="deleteNotepadWorker(item.id)"
              >
                <template #title="{ title }">
                  <span class="fw-bold link-primary stretched-link" v-b-toggle.applicant-sidebar @click="handleWorkerSidebar(item.id)">
                    {{ title }}
                  </span>
                </template>
              </notebook-item>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card v-if="isNotebookCompanyHidden" no-body class="mb-0 border-0">
          <b-card-header header-tag="header" class="accordion-header p-0 fw-light border-0" role="tab">
            <b-button block v-b-toggle.accordion-notebook-3 variant="light"
                      class="accordion-button text-left d-flex align-items-center shadow-none rounded-top-0">
              <span class="fw-bolder">{{ translations[341] }} </span> ({{ notebookCompany.length }})
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-notebook-3" accordion="notebook-accordion" role="tabpanel">
            <b-card-body class="fs-6 px-0 py-3">
              <notebook-item
                v-for="(item, index) in notebookCompany"
                :key="index"
                :id="item.company_id"
                :date="formatDateEuropean(item.last_modified)"
                :title="item.name"
                @delete="deleteNotepadCompany(item.company_id)">
                <template #title="{ title }">
                  <span class="fw-bold link-primary stretched-link" v-b-toggle.company-sidebar @click="handleCompanySidebar(item.company_id, item.name)">
                    {{ title }}
                  </span>
                </template>
              </notebook-item>
            </b-card-body>
          </b-collapse>
        </b-card>

        <b-card v-if="isNotebookCoursesHidden" no-body class="mb-0 border-0">
          <b-card-header header-tag="header" class="accordion-header p-0 fw-light border-0" role="tab">
            <b-button block v-b-toggle.accordion-notebook-4 variant="light"
                      class="accordion-button text-left d-flex align-items-center shadow-none rounded-top-0">
              <span class="fw-bolder">{{ translations[15404] }} </span> ({{ notebookCourses.length }})
            </b-button>
          </b-card-header>
          <b-collapse id="accordion-notebook-4" accordion="notebook-accordion" role="tabpanel">
            <b-card-body class="fs-6 px-0 py-3">
              <notebook-item
                v-for="(item, index) in notebookCourses"
                :key="index"
                :date="formatDateEuropean(item.lastdate)"
                :id="item.id"
                :title="item.course_name"
                :description="item.location"
                @delete="deleteNotepadCourses(item.id)"
              >
                <template #title="{ title }">
                  <span class="fw-bold link-primary stretched-link" @click="handleCoursesSidebar(item.id, item.show_in_new_tab, item.url)">
                    {{ title }}
                  </span>
                </template>
              </notebook-item>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </template>
    <template #footer>
      <b-row>
        <b-col cols="auto" class="ml-auto py-3">
          <b-button variant="primary" size="sm" class="position-relative z-3" @click="deleteAllNotice">
            <b-icon icon="trash" scale="0.9"></b-icon>
            <span class="ms-1" v-b-tooltip.hover :title="translations[13794]">
              {{ translations[13793] }}
            </span>
          </b-button>
        </b-col>
      </b-row>
    </template>
  </core-sidebar>
</template>

<script lang="ts">
import { AppModule, SettingsCounters } from '@/store/modules/app';
import { Component, Vue } from 'vue-property-decorator';
import NotebookItem from '@/components/Notebook/NotebookItem.vue';
import { NotebookModule } from '@/store/modules/notebook';
import { UserModule } from '@/store/modules/user';
import { WorkersModule } from '@/store/modules/workers';
import { ProfessionModule } from '@/store/modules/profession';
import { CompanyModule } from '@/store/modules/company';
import { groupCurses } from '@/config/configuration';
import { CourseModalModule } from '@/store/modules/courses/courseModal';

@Component({
  components: {
    NotebookItem,
  },
})
export default class NotebookSidebar extends Vue {
  get isAuth() {
    return UserModule.isUserAuth;
  }

  get translations() {
    return AppModule.translation;
  }

  get notebookJobs() {
    return NotebookModule.notebookJobs;
  }

  get sid() {
    return AppModule.sid;
  }

  get isCourses() {
    return groupCurses(this.sid);
  }

  get getCounters() {
    return AppModule.settingPortal.counters;
  }

  isShowPage(value: SettingsCounters['name']) {
    return this.getCounters.find((val) => val.name === value)?.visible;
  }

  get isNotebookJobsHidden() {
    return this.isShowPage('jobs');
  }

  get isNotebookWorkersHidden() {
    return this.isShowPage('applicants');
  }

  get isNotebookCompanyHidden() {
    return this.isShowPage('companies');
  }

  get isNotebookCoursesHidden() {
    return this.isShowPage('courses');
  }

  get notebookWorkers() {
    return NotebookModule.notebookWorkers;
  }

  get notebookCompany() {
    return NotebookModule.notebookCompany;
  }

  get notebookCourses() {
    return NotebookModule.notebookCourses;
  }

  async deleteNotepadJob(id: number) {
    if (this.isAuth) {
      await NotebookModule.toogleNotepadItem({ type: 'job', item_id: id, isMarked: true });
    } else {
      NotebookModule.removeJobNotepadItemLocal({ id });
    }
  }

  async deleteNotepadCompany(id: number) {
    if (this.isAuth) {
      await NotebookModule.toogleNotepadItem({ type: 'company', item_id: id, isMarked: true });
    }
  }

  async deleteNotepadWorker(id: number) {
    if (this.isAuth) {
      await NotebookModule.toogleNotepadItem({ type: 'applicant', item_id: id, isMarked: true });
    } else {
      NotebookModule.removeWorkerNotepadItemLocal({ id });
    }
  }

  async deleteNotepadCourses(id: number) {
    if (this.isAuth) {
      await NotebookModule.toogleNotepadItem({ type: 'courses', item_id: id, isMarked: true });
    } else {
      NotebookModule.removeCourseNotepadItemLocal({ id });
    }
  }

  async deleteAllNotice() {
    let userType: 'applicant' | 'company' | 'consultant' | 'courses' | null = null;

    if (UserModule.accessTokenApplicant) {
      userType = 'applicant';
    } else if (UserModule.accessTokenCompany) {
      userType = 'company';
    } else if (UserModule.accessTokenConsultant) {
      userType = 'consultant';
    } else {
      userType = 'courses';
    }

    if (userType) {
      await NotebookModule.DeleteAllNotebookNotes(userType);
    }
  }

  formatDateEuropean(targetDate: string): string {
    if (targetDate) {
      const parts = targetDate.split('-');
      if (parts[2] && parts[1]) {
        return `${parts[2]}.${parts[1]}.${parts[0]}`;
      }
      return `${parts[0]}`;
    }
    return '';
  }

  handleWorkerSidebar(id: number) {
    WorkersModule.SET_SELECTED_WORKER(id);
  }

  handleJobSidebar(id: number, firmName: string, shortview: 1 | 0) {
    ProfessionModule.SetJobId(id);
    ProfessionModule.SetJobFirm(firmName);
    ProfessionModule.SetJobShort(shortview ? 'shortview' : '');
    CompanyModule.SetCompanyDetailFilter({ obj: 'idjob', value: id });
  }

  handleCompanySidebar(id: number, title: string) {
    CompanyModule.HandleCompanySidebar({ id, title });
  }

  get courses() {
    return ProfessionModule.courses.courses;
  }

  async handleCoursesSidebar(id: number, show_in_new_tab: boolean, url: string) {
    if (show_in_new_tab) {
      window.open(url, '_blank');
    } else {
      const index = this.courses.findIndex((el:any) => el.id === id);
      const course = this.courses.find((el:any) => el.id === id);
      CourseModalModule.UPDATE_CURRENT_COURSE(course);
      await CourseModalModule.UPDATE_CURRENT_COURSE_INDEX(index);
      CourseModalModule.UPDATE_CURRENT_COURSES_LIST(this.courses);
      this.$bvModal.show('course-modal-frame');
    }
  }
}
</script>
<style scoped lang="scss">
.icon-event {
  transition: all .2s ease-in;
}

.accordion-button {
  color: #4d6069!important;
  &.not-collapsed {
    .icon-event {
      transform: rotate(90deg);
    }
  }
}
</style>
